/**
 * Tabs — vendored from shadcn/ui on @radix-ui/react-tabs and restyled as the
 * §7.8 underline tabs (NFR-008): 40px tall, 14/500, navy-600 at rest, navy-950
 * with a 2px Sky-burst underline when active, 1px navy-200 baseline under the
 * list. Screens reflect the active tab into the URL query (sheet 20 callout 7).
 */
import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from './cn'

export const Tabs = TabsPrimitive.Root

export const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('flex h-10 w-full items-stretch gap-6 border-b border-navy-200', className)}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

export const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      '-mb-px inline-flex h-10 items-center gap-2 whitespace-nowrap border-b-2 border-transparent px-1 text-body font-medium text-navy-600 transition-colors duration-[var(--duration-fast)]',
      'hover:text-navy-950 focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]',
      'disabled:cursor-not-allowed disabled:opacity-45',
      'data-[state=active]:border-brand-sky data-[state=active]:text-navy-950',
      className,
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

export const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn('mt-4 focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]', className)}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName
